module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-3-fad1262c1f303a1465323945cabbe731.webp";